import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
`;

export const Select = styled.select`
  height: 42px;
  width: 100%;
  padding: 0 40px 0 12px;
  box-sizing: border-box;
  background-color: ${({ bgColor }) => bgColor};
  outline-color: ${({ oColor }) => oColor};
  border: 1px solid ${({ bColor }) => bColor};
  border-radius: 4px;
  -webkit-appearance: none;
  -moz-appearance: none;

  option {
    font-size: 14px;
  }
`;

export const ToggleIcon = styled.div.attrs(() => ({
  type: 'button',
}))`
  position: absolute;
  pointer-events: none;
  text-align: center;
  line-height: 40px;
  top: 1px;
  right: 1px;
  height: 40px;
  width: 40px;
  border-radius: 20px;
  font-size: 12px;
  border: none;
  background: none;
  cursor: pointer;
  color: ${({ color }) => color};
`;
